import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/funcionarioCargo' };
/////////////////////////////////////////////////////////////////////////////////

export function createFuncionarioCargoCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateFuncionarioCargoCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listFuncionarioCargoCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findFuncionarioCargoCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllFuncionarioCargoCadastro() {
  return httpService.get({ ...args, path: '/funcionarioCargo/all' });
}

export function deleteFuncionarioCargoCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

